// Cookies
function createCookie(cookieName,cookieValue,daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime()+(daysToExpire*24*60*60*1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
}

function accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(';');
    for(var i=0; i<allCookieArray.length; i++) {
        var temp = allCookieArray[i].trim();
        if (temp.indexOf(name)==0)
        return temp.substring(name.length,temp.length);
    }
    return "";
}

function setCookieCloseBox(cookieName) {
    createCookie(cookieNaam, 'closed', days); // create cookie 
    document.body.removeEventListener("mouseleave", userLeave); // prevent box from reappearing
    document.body.classList.remove('newsletterbox-active'); // hide newsletter box
}

// Newsletter
function newsletterPopup() {
    var newsletterBox = document.getElementById("newsletterbox");
    if (newsletterBox) {
        var cookieNaam = "newspopup";
        var isCookie = accessCookie(cookieNaam);

        var days = newsletterBox.dataset.expire; // Get days from data-expire
        var cdown = newsletterBox.dataset.cdown; // Get count down from data-cdown
        var tnx = newsletterBox.dataset.thanks; // Get thanks from data-tnx
        var err = newsletterBox.dataset.err; // Get error from data-err
        var mail = newsletterBox.dataset.mail; // Get mail from data-mail

        if (days === undefined) { var days = 7; }
        if (cdown === undefined) { var cdown = 30000; }
        if (tnx === undefined) { var tnx = "Thanks for signing up!"; }
        if (err === undefined) { var err = "There was an error in submitting the form."; }
        if (mail === undefined) { var mail = "Please fill in your email address."; }

        // Countdown: show after X sec
        function countDownr(event) {
            setTimeout(function() {
                document.body.classList.add('newsletter-active'); // show newsletter box
            }, cdown);
        }

        // Check if user tries to leave from top
        function userLeave(event) {
            if(event.clientY <= 0) {
                document.body.classList.add('newsletter-active'); // show newsletter box
            }
        }

        // If cookie is not set show newsletter box
        if(isCookie !== 'closed') {
            countDownr(); // start countdown
        }

        // If is challenge page
        var challengeUrl = window.location.origin +'/challenge#contact_form';
        var currentUrl = window.location;
        if(currentUrl == challengeUrl) {
            document.getElementById('newsletterbox').style.display = 'none';
        }

        // Set cookie for "X" days and close newsletter box
        function setCookieNclose() {
            createCookie(cookieNaam, 'closed', days); // create cookie 
            document.body.removeEventListener("mouseleave", userLeave); // prevent box from reappearing
            document.body.classList.remove('newsletter-active'); // hide newsletter box
        }

        // On click Set cookie for "X" days and close newsletter box
        document.getElementById('closenewsletter').addEventListener("click", function() {
            setCookieNclose();
        });

        // Newsletter submit thru AJAX
        // TODO: convert in Vanilla JS
        $('form.contact-form').submit( function(){
            $('p.msg.is-green, p.msg.is-red').remove();
            if($(this).find('input[type="email"]').val() !== '') {
                var data = $(this).serialize();
                $.ajax({
                    type: "POST",
                    url: "/contact#contact_form",
                    data: data,
                    crossDomain: true,
                    success: function(response, textStatus, xhr) {
                        $('.contact-form').append('<p class="msg is-green">'+tnx+'</p>');
                        setTimeout(function(){ 
                            setCookieNclose(); 
                        }, 3000);
                    }, error: function(XMLHttpRequest, textStatus, errorThrown) {
                        $('.contact-form').append('<p class="msg is-red">'+err+'</p>');
                    }
                });

                // If customer is challenged
                if(response.status == 429) {
                    var challengeUrl = window.location.origin +'/challenge#'
                    window.location = challengeUrl
                }
            } else {
                $(this).append('<p class="msg is-red">'+mail+'</p>');
            }
            return false;
        });

        // When customer is back from challenge
        var checkURL = ["?customer_posted=true", "?contact%5Btags%5D=newsletter&form_type=customer"];
        for (var i = 0; i < checkURL.length; i++) {
            if(window.location.href.indexOf(checkURL[i]) > -1) {
                // Show newsletter box
                document.body.classList.add('newsletter-active');
                setTimeout(function(){
                    setCookieNclose(); 
                }, 5000);
            }
        }
    }
}
// Toggle Body Class
    let toggleBodyClass = function(arg) {
        document.body.classList.toggle(arg);
    }
// Get Element Height
function getElementHeight(targetElement,appendTo,cssVar) {
    let element = document.querySelector(targetElement);

    if (element) {
        let elementHeight = element.offsetHeight;
        document.querySelector(appendTo).style.setProperty(cssVar, `${elementHeight}px`);
    }
}

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
function getSetVh() {
    let vh = window.innerHeight * 0.01;
    document.body.style.setProperty('--vh', `${vh}px`);
}

window.addEventListener('resize', () => {
    getSetVh();
});

// Toggle
    let toggleClass = function(qSelectors, bodyClass) {   
        let elArray = document.querySelectorAll(qSelectors);
        elArray.forEach(function(e) {
            e.addEventListener("click", function() {
                toggleBodyClass(bodyClass);
            });
        });
    }
// Menu
    let toggleMenu = function() {
        // `.fire-menu` used to be listed here too. It was a <span> in the accounts list that
        // `#header .accounts .small-only.hamburger { display: none }` hid unconditionally, so
        // it could never be clicked or focused; it is deleted from the markup. `.shrink-menu`
        // is the close control inside the panel and still needs to work.
        toggleClass('.shrink-menu', 'open-menu');
    }
// Search
    let toggleSearch = function() {
        toggleClass('.fire-search, .shrink-search', 'open-search');
    }
/* Keep `aria-expanded` on the disclosure triggers in step with the body class that actually
 * drives the panels. Observing the class rather than wiring each trigger means the state stays
 * right no matter which path opened or closed it — the trigger, the panel's own close button,
 * or anything else that reaches for `toggleBodyClass`.
 *
 * Search only. `.new_hamburger_icon` used to be listed here, but the panel it opens is a modal
 * dialog (see `modalPanel` below), and `aria-expanded` belongs to disclosures, not dialogs. */
    let syncExpandedState = function() {
        const disclosures = [
            { trigger: '.fire-search', bodyClass: 'open-search' },
        ];

        const sync = function() {
            disclosures.forEach(function(d) {
                const open = document.body.classList.contains(d.bodyClass);
                document.querySelectorAll(d.trigger).forEach(function(el) {
                    el.setAttribute('aria-expanded', String(open));
                });
            });
        };

        sync();
        new MutationObserver(sync).observe(document.body, {
            attributes: true,
            attributeFilter: ['class'],
        });
    }

// Dropdown menu header
function dropdownMenu() {
    const detailsElements = document.querySelectorAll("details.lv1");

    function handleClickOnDetails() {
      // close all details
      let detailsOpened = document.querySelectorAll("details[open].lv1");

      for (const item of detailsOpened) {
        if (this != item) {
          item.removeAttribute("open");
        }
      }
    }

    detailsElements.forEach(function (item) {
      item.addEventListener("click", handleClickOnDetails);
    });
}

// Close <details> when you click outside
var details = [...document.querySelectorAll('details')];
document.addEventListener('click', function(e) { 
    if (!details.some(f => f.contains(e.target))) { 
        details.forEach(f => f.removeAttribute('open')) 
    } else { 
        details.forEach(f => !f.contains(e.target) ? f.removeAttribute('open') : '') 
    } 
});

// update button price on variant change 
function updatePrice(obj,idd) {
  var uid = obj.options[obj.selectedIndex].getAttribute('data-price');
  var cid = obj.options[obj.selectedIndex].getAttribute('data-com-price');
  console.log('cid', cid)
  var pb = document.querySelector('.uprice'+idd);
  var cpb = document.querySelector('.upricedel'+idd);
  pb.innerHTML = uid;
   cpb.innerHTML = cid;
}

function selectOptions(obj,idd) { updatePrice(obj,idd); }

$('body').on('change', '.productSelect', function() {
  var variant_link = $(this).find('option:selected').attr('data-link');
  var product_id = $(this).data('product-id');
  var primary_img = $(this).find('option:selected').data('image-primary');
  
  $('.card-' + product_id).find('a').attr('href',variant_link);
  $('.primary-' + product_id + ' picture img').attr('src', primary_img);
  $('.primary-' + product_id + ' picture img').attr('srcset', primary_img); 
  
});

/*** init app */
function app() {
    getSetVh(); // get Viewport Height
    dropdownMenu(); // Dropdown menu
    newsletterPopup(); // Newsletter popup
    toggleMenu(); // toggle Menu
    toggleSearch(); // toggle Search
    syncExpandedState(); // keep aria-expanded on the disclosure triggers accurate
  
}

/*** on DOM ready **/
document.addEventListener("DOMContentLoaded", () => { app() })



/* Collection sort
 * ---------------
 * The "nice select" widget that used to be built here is now rendered in Liquid by
 * snippets/global-sort-combobox.liquid and driven by dev/js/web-components/combo-box.js.
 * It replaced the real <select> with `<a href="#">` markup carrying no combobox or listbox
 * roles, while hiding the <select> itself with `display: none` — between them, the sort order
 * could not be changed without a pointer.
 *
 * The sorting below is unchanged apart from its trigger: it listens for `change` on the
 * native <select> that the component writes to, rather than for clicks on generated <li>
 * elements, and reads the value from the select rather than from the element's class name.
 */
/* Scoped to #SortBy by id, not to `select[name="sort_by"]`: the filters panel
 * (snippets/global-filters.liquid) renders a second select with that same name, inside a form
 * with its own Apply button. Matching on the name would make that one sort on every change and
 * race its own form submission. */
$('body').on('change', '#SortBy', function () {
  var criteria = $(this).val();
  if (!criteria) return;

  var url = location.pathname;
  var handle = $('#ajaxSection_pro').attr('data-handle');
  var url_path;

  if (window.location.href.indexOf('page=') > -1) {
    url_path = '/collections/' + handle + '?sort_by=' + encodeURIComponent(criteria);
  } else {
    url_path = url + '?sort_by=' + encodeURIComponent(criteria);
  }

  $.ajax({
    url: url_path,
    type: 'GET',
    success: function (data) {
      var section = $(data).find('#ajaxSection_pro').html();
      history.pushState(null, null, url_path);
      $('#ajaxSection_pro').html(section);
    }
  });
});


$(window).scroll(function () {
if($('.bn_facet-filters').length > 0){
      var btn = $('.bn_facet-filters').offset().top;
      var header_top = $('#header').outerHeight();
      var win = $(window).scrollTop() + header_top + 1;
      if(win >= btn) {
        $('.bn_select-main').addClass('sticky_filter').css('top',header_top+'px');
      }else{
        $('.bn_select-main').removeClass('sticky_filter').css('top','unset');
      }
    }
});

var delay_slide = parseInt($('.our_book_slider .swiper-wrapper').attr('data-slide-delay'));
// let delayspeed = 5;
var Swipes = new Swiper('.our_book_slider', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: '.swiper-button-next.our_book_arrow',
      prevEl: '.swiper-button-prev.our_book_arrow',
    },
    pagination: {
      el: ".swiper-pagination.our_book_dots",
    },
    autoplay:{
      delay: delay_slide,
    }
});

/* The mega menu open/close handlers that used to live here are now
 * dev/js/components/mega-menu.js, auto-loaded from the `data-component="mega-menu"` on the
 * nav list. There were two of them, gated on `$(window).width() < 1367` and `< 992`; both
 * matched the same trigger, so between those widths they double-fired against each other,
 * and because the outer gate ran once at page load a resize past it broke them either way.
 * Neither bound anything at desktop width, where the panel opened from a CSS :hover rule —
 * which is why the menu could not be opened from the keyboard at all. */

function headerspace() {
    setTimeout(function() {
        var headerHeight = $('#header').outerHeight();
        var announcementbar = $('.announcement-bar').outerHeight();
        $('.main_new_menulinks').css("top", headerHeight + announcementbar);
    }, 1000);
}
headerspace();
$(window).on('resize orientationchange', function () {
    headerspace();
});


$("body").on("click", ".new_hamburger_icon", function (e) {
  e.preventDefault();
  if($(this).hasClass("is-open")){
    $(".new_hamburger_icon, .main_new_menulinks").removeClass("is-open");
    $("body").removeClass("is-open");
  }else{
    $(this).addClass("is-open");
    $(".main_new_menulinks").addClass("is-open");
    $("body").addClass("is-open");
  }
});

let PDPSwiper = null;

// function handleSwiper() {
//   const isDesktop = window.innerWidth >= 778;
//   const carouselOuter = document.querySelector('.product-image-carousel'); 

//   // Always destroy first (if exists)
//   if (PDPSwiper) {
//     PDPSwiper.destroy(true, true);
//     PDPSwiper = null;
//   }
  
//   // Then init only for desktop
//   if (isDesktop || carouselOuter.classList.contains('scroll-snap')) {
//     PDPSwiper = new Swiper('.product-image-carousel-swiper', {
//       loop: true,
//       slidesPerView: 1,
//       spaceBetween: 10,
//       navigation: {
//         nextEl: '.swiper-button-next.product_arrow',
//         prevEl: '.swiper-button-prev.product_arrow',
//       },
//       pagination: {
//         el: ".swiper-pagination.product_dots",
//       }
//     });
//   }
// }


function handleSwiper() {
  PDPSwiper = new Swiper('.product-image-carousel-swiper', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next.product_arrow',
      prevEl: '.swiper-button-prev.product_arrow',
    },
    pagination: {
      el: ".swiper-pagination.product_dots",
    }
  }); 
}

// Initial run
handleSwiper();

// Resize
window.addEventListener('resize', handleSwiper);